import React from 'react'
import Fragment from '../common/fragment'


function FragmentAD(props) {
  return (
    <Fragment pos="d" {...props}>
      <p>
        Necesitamos cuerdas que nos saquen del abismo, dice Donna Haraway (bióloga y
filósofa). Su perra se llama Cayanne y ella dice que también escribe. ¿Cuál será la
escritura de otros seres que sin lenguaje pudieran describir el mundo? Las palomas
del antiguo convento agustino, de color rojo y con puertas de madera, conserjes de
estos soliloquios de las piedras y el humo, forman un coro de escribanas, que relata
fábulas medievales, tardo-modernas, inquietantes y locuaces. Ellas cantan a las
llamaradas de las usinas y al polvo de los trenes. Al tráfago de una ciudad y a las
ovejas del valle.
      </p>
    </Fragment>
  )
}


export default FragmentAD
